var Arabic = "(عربي) Arabic";
var Chinese = "(中文) Chinese";
var English = "English";
var French = "(Français) French";
var German = "(Deutsch) German";
var Greek = "(Ελληνικά) Greek";
var Italian = "(Italiano) Italian";
var Japanese = "(日本語) Japanese";
var Portuguese = "(Português) Portuguese";
var Russian = "(Pусский) Russian";
var Spanish = "(Español) Spanish";
var Taiwanese = "(正體中文) Traditional Chinese";
var EN_TRANSLATION = {
  Arabic: Arabic,
  Chinese: Chinese,
  English: English,
  French: French,
  German: German,
  Greek: Greek,
  Italian: Italian,
  Japanese: Japanese,
  Portuguese: Portuguese,
  Russian: Russian,
  Spanish: Spanish,
  Taiwanese: Taiwanese
};
export { Arabic, Chinese, English, French, German, Greek, Italian, Japanese, Portuguese, Russian, Spanish, Taiwanese, EN_TRANSLATION as default };
//# sourceMappingURL=en.json.mjs.map
